import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareListRowSizeMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  listRowSize?: Types.InputMaybe<Types.AssetAggregateListRowSizeEnum>;
}>;


export type UpdateShareListRowSizeMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', listRowSize: Types.AssetAggregateListRowSizeEnum } } | { __typename?: 'CollectionShare', id: string, appearance: { __typename?: 'AssetAggregateAppearance', listRowSize: Types.AssetAggregateListRowSizeEnum } } | null } | null };


export const UpdateShareListRowSize = /*#__PURE__*/ gql`
    mutation UpdateShareListRowSize($shareId: ID!, $listRowSize: AssetAggregateListRowSizeEnum) {
  updateShare(input: {shareId: $shareId, appearance: {listRowSize: $listRowSize}}) {
    share {
      id
      ... on AssetAggregate {
        appearance {
          listRowSize
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareListRowSizeMutation, UpdateShareListRowSizeMutationVariables>;

          

          export const useUpdateShareListRowSizeMutation = (options?:MutationHookOptions<UpdateShareListRowSizeMutation, UpdateShareListRowSizeMutationVariables>) => useMutation(UpdateShareListRowSize, options);
          

          export type UpdateShareListRowSizeMutationOptions = MutationHookOptions<UpdateShareListRowSizeMutation, UpdateShareListRowSizeMutationVariables>;

          

          export type UpdateShareListRowSizeMutationResult = ReturnType<typeof useUpdateShareListRowSizeMutation>[1];

          
